import { useContext, useEffect, useState } from 'react';

import { ReadyForUpdateContext } from '../AppUpdate';

interface ReadyForUpdateProps {
    delayMs?: number;
}

const useReadyForUpdate = (props?: ReadyForUpdateProps) => {
    const [readyTimer, changeReadyTimer] = useState<number | null>(null);
    const readyForUpdatecontext = useContext(ReadyForUpdateContext);

    const delayMs: number = props?.delayMs ? props.delayMs : 0;

    useEffect(() => {
        if (readyTimer !== null) {
            window.clearTimeout(readyTimer);
        }
        if (delayMs >= 0) {
            const timer = window.setTimeout(() => {
                readyForUpdatecontext.readyForUpdateChange(true);
            }, delayMs);
            changeReadyTimer(timer);
            return () => {
                window.clearTimeout(timer);
            };
        } else {
            readyForUpdatecontext.readyForUpdateChange(false);
        }
    }, [delayMs]);
};

export default useReadyForUpdate;
